import { gql } from '@src/lib/gql'

export const ADVISOR_DIRECTORY = gql`
  query DirectorySectionAdvisorDirectory(
    $categoryKey: String
    $keywords: String
    $acceptingSessions: Boolean
    $page: Int
    $pageSize: Int
  ) {
    advisorDirectory(
      categoryKey: $categoryKey
      keywords: $keywords
      acceptingSessions: $acceptingSessions
      page: $page
      pageSize: $pageSize
    ) {
      items {
        id
        advisorProfileId
        headline
        bioForAdvising
        advisingNote
        hourlyRate
        canAcceptSessions
        isFeatured
        categoryKeys
        categories {
          id
          key
          title
        }
        user {
          id
          userId
          slug
          fullName
          displayName
          title
          shortBio
          pictureUrl
          sessionReviewSummary {
            averageScore
            count
          }
        }
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageSize
        pageCount
      }
    }
  }
`
